import { useEffect, useState } from 'react';
import * as signalR from '@microsoft/signalr';
import { useQueryClient } from 'react-query';
import { API_SERVER } from '../utils/constants';

export const useHomePageSignalR = () => {
  const queryClient = useQueryClient();
  const [signalRData, setSignalRData] = useState([]);

  useEffect(() => {
    let token = localStorage.getItem('accessToken');

    if (!token) {
      console.error('❌ SignalR Token Bulunamadı!');
      return;
    }

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${API_SERVER}/hub?topics=home`, {
        accessTokenFactory: () => token,
        transport:
          signalR.HttpTransportType.WebSockets |
          signalR.HttpTransportType.LongPolling,
        withCredentials: true,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connection.start().catch();

    connection.on('ReceiveHomePage', rawData => {
      let parsedData;

      try {
        if (typeof rawData === 'string') {
          parsedData = JSON.parse(rawData);
        } else {
          parsedData = rawData;
        }
        if (!Array.isArray(parsedData)) {
          console.error('🚨 SignalR Data is not an array:', parsedData);
          return;
        }

        setSignalRData([...parsedData]);

        queryClient.setQueryData('deviceValues', parsedData);
      } catch (error) {
        console.error('❌ JSON parse hatası:', error);
      }
    });

    return () => {
      connection.stop();
    };
  }, [queryClient]);

  return signalRData;
};
